import * as types from './mutation-types';
import * as actions from './actions';

const state = {
    productionPlanning: {},
    harvestForecast: {}
}

const getters = {
    productionPlanning: state => state.productionPlanning,
    harvestForecast: state => state.harvestForecast
}

const mutations = {
    [types.GET_PRODUCION_PLANNING_DATA](state, response){
        state.productionPlanning = response;
    },
    [types.GET_HARVEST_FORECAST_REQUEST](state, harvestForecast){
        state.harvestForecastLoading -= 1
        state.harvestForecastError = ''
        state.harvestForecast = harvestForecast;
    },
    [types.GET_HARVEST_FORECAST_SUCCESS](state, harvestForecast){
        state.harvestForecastLoading -= 1
        state.harvestForecastError = ''
        state.harvestForecast = harvestForecast;
    },
    [types.GET_HARVEST_FORECAST_FAILURE](state, harvestForecast){
        state.harvestForecastLoading -= 1
        state.harvestForecastError = ''
        state.harvestForecast = harvestForecast;
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}
